export const PARAMETERS = 'parameters';

// FTS0004
export const FTS0004_TREATMENT_KEY = 'fts-0004';
export const FTS0004_GROUP_PARAMETER_KEY = 'group';
export let FTS0004_GROUP_PARAMETER_OPTIONS;
(function (FTS0004_GROUP_PARAMETER_OPTIONS) {
  FTS0004_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS0004_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS0004_GROUP_PARAMETER_OPTIONS || (FTS0004_GROUP_PARAMETER_OPTIONS = {}));